import axios from "axios";

export const ApiSms = axios.create({
    baseURL: "https://sms.sitgps.com",
    headers: { 'Content-Type': 'application/json' },
});
ApiSms.defaults.headers.common['Appid'] = 'sitgps';